import React from "react";
import Card from "../components/card";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Nuestros servicios</h2>
        </div>
        <div className="container">
          <Card />
          {/* <div className="row rowService">
            {props.data
              ? props.data.map((d, i) => (
                  <div key={`${d.name}-${i}`} className="col-sm-4 modS">
                    {" "}
                    <div>
                      <i className={d.icon}></i>
                      <div className="service-desc">
                        <h3>{d.name}</h3>
                        <p>{d.text}</p>
                      </div>
                    </div>
                  </div>
                ))
              : "loading"}
          </div>*/}
        </div>
      </div>
    </div>
  );
};
